// extracted by mini-css-extract-plugin
export var infoRow = "_re-2";
export var labelContainer = "_re-0";
export var rightInfo = "_re-1";